<div class="header-cta">
  <span class="header-cta-prompt">Questions about lessons?</span>
  <div class="header-cta-actions">
    <a grooveAction size="sm" [href]="phoneHref">Call Russ</a>
    <a grooveAction size="sm" variant="ghost" [href]="emailHref"
      >or send an email</a
    >
  </div>
</div>
